import { combineReducers } from 'redux';

import { validacoes } from './validacoes/reducer';
import { permissoes } from './permissoes/reducer';

export const rootReducer = combineReducers({
  validacoes,
  permissoes,
});
